const OfferScopeListTableLangKey = [
	'column_id',
	'column_name',
	'column_offer_id',
	'column_notes',
	'column_affiliate_network',
	'column_country',
	'column_sales_cap',
	'column_diff',
	'column_cap_type',
	'column_status'
] as const

type IOfferScopeListTableLangKey = typeof OfferScopeListTableLangKey[number]

export type IOfferScopeListTableLang = {
	offer_scope_list_table: Record<IOfferScopeListTableLangKey, string>
}

const langEntries = OfferScopeListTableLangKey.map(
	(key: IOfferScopeListTableLangKey) => [key, `offer_scope_list_table.${key}`]
)

const langObj: Record<IOfferScopeListTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SCOPE_LIST_TABLE_LANG_KEY: IOfferScopeListTableLang = {
	offer_scope_list_table: langObj
}
